// GENERATED FILE - do not edit.
// Emitted by tools/generate-wire-schemas.mjs from
// Server/src/Shared/Server/Resources/openapi.json (the spec lockfile).
// Regenerate with: npm run generate:wire
//
// Base wire shape for the server "User" component. The corresponding
// *.schema.ts is the facade that names it (and hosts any future refinement);
// see design/wiki/wire-schemas.md.
import { z } from "zod";
import { Role } from "./role.enum.gen";
import { UserInviteMode } from "./user-invite-mode.enum.gen";

export const UserGenShape = z.strictObject({
  id: z.string(),
  teamId: z.string(),
  firstName: z.string().optional(),
  lastName: z.string().optional(),
  email: z.string(),
  phoneNumber: z.string().optional(),
  jobTitle: z.string().optional(),
  roles: z.array(z.enum(Role)),
  inviteMode: z.enum(UserInviteMode),
  activated: z.boolean(),
  created: z.string().optional(),
  lastLogin: z.string().optional(),
  lastLoginReminder: z.string().optional(),
  expiry: z.string().optional(),
  notificationsEnabled: z.boolean(),
  azureAdObjectId: z.string().optional(),
  azureAdTenantId: z.string().optional(),
});
